import { createStore } from "vuex";

import sso from "./api/sso";
import web from "./api/web";

import { getSession } from "@/store/funcs";

export default createStore({
	state: {
		token: getSession("token"),
		siteConfig: getSession("siteConfig"),
		siteMenu: getSession("siteMenu"),
		agreement: getSession("agreement"),
	},
	getters: {},
	mutations: {},
	actions: {},
	modules: {
		sso,
		web,
	},
});
